import { render, staticRenderFns } from "./SkillCategoryCard.vue?vue&type=template&id=08f1b92e&"
import script from "./SkillCategoryCard.vue?vue&type=script&lang=js&"
export * from "./SkillCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports